import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL
export default {
	namespaced: true,
	state: {

		gestores_ids: [],
	},
	mutations: {

		set_gestores_ids(state, value) {
			state.gestores_ids = value
		},
		
	},
	actions: {
	},
}
